import { render, staticRenderFns } from "./OutStock.vue?vue&type=template&id=2857eada"
import script from "./OutStock.vue?vue&type=script&lang=js"
export * from "./OutStock.vue?vue&type=script&lang=js"
import style0 from "./OutStock.vue?vue&type=style&index=0&id=2857eada&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports